<div>
    <div [ngStyle]="{'padding-top':'10px', 'max-height':'67px'}">
        <div class="expansion-filter" (click)="filtroUsuarioExpandido = !filtroUsuarioExpandido" 
        *ngIf="(listaUsuarios?.ativos && listaUsuarios?.ativos.length) || (listaUsuarios?.inativos && listaUsuarios?.inativos.length)">
            <span class="subtitle-medium">
                Usuários
            </span>
            <mat-icon mat-list-icon [svgIcon]="'menu-up'" [@animationRotate]="filtroUsuarioExpandido ? 'open' : 'close'"
                class="icon-expansion"></mat-icon>
        </div>
        <div class="container-filter" [@animationShowHide]="filtroUsuarioExpandido ? 'open' : 'close'"  
        *ngIf="(listaUsuarios?.ativos && listaUsuarios?.ativos.length) || (listaUsuarios?.inativos && listaUsuarios?.inativos.length)">
            <mat-radio-group [(ngModel)]="filtroUsuario">
                <div class="item-filter">
                    <div class="all-users">
                        <span class="paragraph-regular">TODOS</span>
                            <mat-radio-button color="primary" [value]="false"></mat-radio-button>
                    </div>
                </div>

                <div class="item-filter" *ngIf="listaUsuarios?.ativos.length">
                    <span class="paragraph-regular-xs color-sub-title">Ativos</span>
                    <div class="lista" [ngClass]="[listaUsuarios?.ativos && listaUsuarios.ativos.length > 8 ? 'overflow-lista' : '' ]">
                        <div class="item" *ngFor="let usuario of listaUsuarios.ativos">
                            <div class="container-nome">
                                <img [src]="usuario.img" onError="this.src='assets/img/usuarioAnonimo.png'">
                                <span>{{usuario.nome}}</span>
                            </div>
                            <mat-radio-button color="primary" [value]="usuario.email"></mat-radio-button>
                        </div>
                    </div>
                </div>

                <div class="item-filter" *ngIf="listaUsuarios?.inativos.length">
                    <span class="paragraph-regular-xs color-sub-title">Inativos</span>
                    <div class="lista" [ngClass]="[listaUsuarios?.inativos && listaUsuarios.inativos.length > 8 ? 'overflow-lista' : '' ]">
                        <div class="item" *ngFor="let usuario of listaUsuarios.inativos">
                            <div class="container-nome">
                                <img [src]="usuario.img" onError="this.src='assets/img/usuarioAnonimo.png'">
                                <span>{{usuario.nome}}</span>
                            </div>
                            <mat-radio-button color="primary" [value]="usuario.email"></mat-radio-button>      
                        </div>
                    </div>
                </div>
            </mat-radio-group>    
        </div>
        <div class="expansion-filter" (click)="filtroStatusNegocioExpandido = !filtroStatusNegocioExpandido">
            <span class="subtitle-medium">
                Status do Negócio
            </span>
            <mat-icon mat-list-icon [svgIcon]="'menu-up'" [@animationRotate]="filtroStatusNegocioExpandido ? 'open' : 'close'"
                class="icon-expansion"></mat-icon>
        </div>
        <div class="container-filter" [@animationShowHide]="filtroStatusNegocioExpandido ? 'open' : 'close'">
            <div class="item-filter">
                <div class="lista">
                    <div class="item" *ngFor="let negocio of listaStatusNegocio">
                        <div class="container-nome">
                            <span>{{negocio.viewValue}}</span>
                        </div>
                        <mat-checkbox color="primary" [(ngModel)]="negocio.ativo" (ngModelChange)="atualizaFiltroStatusNegocio(negocio.value, $event)"></mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="actionButtonsFiltros">
        <button mat-button class="btn-limpar-filtro" (click)="clearFilter()">LIMPAR FILTROS</button>
        <button mat-raised-button class="btn-filtro" (click)="buildString()">APLICAR</button>
    </div>
</div>